/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HabitActivity = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
};
export function HabitActivityFromJSON(json) {
    return HabitActivityFromJSONTyped(json, false);
}
export function HabitActivityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HabitActivityToJSON(value) {
    return value;
}
